import { VIDEO_PLAYER_TYPE } from '.';

// types
import type { VideoPlayerProps } from '.';

const VIDEO_PLAYER_ID = 'F2-cZcup6X4DpJuXo-bCod';
const VIDEO_PLAYER_ID_FOR_BACKGROUND_VIDS = 'D1rCWaT_n-UaJfGWbSk2ZN';
const VIDEO_PLAYER_SCRIPT_ID = 'mi24-js-script';

export function addDefaultValuesToMissingPropsValues(
  props: VideoPlayerProps,
): Omit<VideoPlayerProps, 'title'> {
  const videoPlayerProps: Omit<VideoPlayerProps, 'title'> = {
    cssID: props.cssID,
    inView: props.inView,
    loopType: props.loopType,
    playerType: props.playerType ?? VIDEO_PLAYER_TYPE.FOREGROUND,
    playerID: getVideoPlayerID(props),
    video: props.video,
    heading: props.heading,
    subheading: props.subheading,
    button: props.button,
    color: props.color,
    fallbackImg: props.fallbackImg,
  };

  return videoPlayerProps;
}

export function addVideoPlayer(props: Omit<VideoPlayerProps, 'title'>): void {
  const {
    cssID: cssId,
    playerID: playerId,
    video: { videoId },
  } = props;

  const initPlayer = {
    success: function (playerApi) {
      playerApi.play();
      playerApi.toggleMute();
    },
    parameters: {
      mi24VideoPlayer: 'true',
      // disableAutoCreation: 'true',
      configType: 'vmpro',
      playerId,
      videoId,
      apiUrl: '//d.video-cdn.net/play',
      flashPath: '//e.video-cdn.net/v2/',
      token: '***',
    },
  };
  try {
    // if VideoPlayer component is unmounded then the element with the id=cssId is not available
    // addPlayerById will throw an error if the element is not available
    window.VideoPlayer.Collection.addPlayerById(cssId, initPlayer);
    window.VideoPlayer.Collection.rejectAnalytics();
  } catch (error) {}
}

export function addVideoPlayerScript(): void {
  if (!isSSR()) {
    const mi24Script = document.getElementById(VIDEO_PLAYER_SCRIPT_ID);
    if (!mi24Script) {
      const script = document.createElement('script');

      document.head.appendChild(script);

      script.id = VIDEO_PLAYER_SCRIPT_ID;
      script.type = 'text/javascript';
      script.src = 'https://e.video-cdn.net/v2/embed.js';
      script.async = true;
      script.addEventListener('load', () => {
        script.setAttribute('data-loaded', 'true');
      });
    }
  }
}

export function getIsVideoPlayerScriptAvailable(): boolean {
  let ret = false;
  const id = VIDEO_PLAYER_SCRIPT_ID;

  if (isSSR()) return false;
  const mi24Script = document.getElementById(id);
  if (mi24Script && mi24Script.getAttribute('data-loaded')) {
    ret = true;
  }
  return ret;
}

export function getIsVideoPlayerInitialized(cssID: string): boolean {
  if (isSSR()) return false;
  const player = getVideoPlayer(cssID);

  return Boolean(player);
}

export function getVideoPlayer(cssID: string) {
  const id = cssID;

  //FIX: For mobile, the mi-cover needs to be clicked that the video player is loaded/created.
  const elements = document.querySelectorAll('#' + id + ' .mi-cover');
  if (elements) {
    for (const element of elements) {
      (element as HTMLVideoElement).click();
    }
  }
  let player: null | Mi24Player = null;
  try {
    player = window.VideoPlayer?.Collection.getPlayerById(id);
  } catch (err) {
    // Ignore the error here, if the player was not found an exception is thrown that the player by id does not exists.
  }
  return player;
}

function getVideoPlayerID(props: VideoPlayerProps): string {
  if (props?.playerType === VIDEO_PLAYER_TYPE.BACKGROUND)
    return VIDEO_PLAYER_ID_FOR_BACKGROUND_VIDS;

  return VIDEO_PLAYER_ID;
}

function isSSR(): boolean {
  return typeof document === 'undefined' || typeof window === 'undefined';
}

export function removeVideoPlayerControls(cssID: string): void {
  if (isSSR()) return;

  const videoContainer = document.getElementById(cssID);

  const playerNode = videoContainer?.querySelector<HTMLVideoElement>(`video`);
  if (playerNode) playerNode.removeAttribute('controls');

  const controls = videoContainer?.querySelector<HTMLDivElement>('.mi-controls');
  if (controls) controls.style.display = 'none';

  const muteIconNode = document.querySelector('[data-mi-player-role="mi-mute-icon"]');

  if (muteIconNode) {
    muteIconNode.remove();
  }
}
